module.exports = {
  messages: {
    CN: {
      'customer.customerinfo': '客户信息',
      'customer.officialaccount': '关注公众号',
      'customer.availablepoints': '可用积分',
      'customer.sourceofregistration': '注册来源',
      'customer.registrationtime': '注册时间',
      'customer.orderquantity': '订单数量',
      'customer.blacklist': '黑名单',
      'customer.recentactivetime': '最近活跃时间',
      'customer.accumulatedamount': '累计金额',
      'customer.sureblock': '你确定要拉黑吗？',
      'customer.relievesureblock': '你确定要解除拉黑吗？',
      'customer.block': '拉黑',
      'customer.relieveblock': '解除拉黑',
      'customer.loginfrontend': '登录前端',
      'customer.email': '邮箱',
      'customer.customername': '姓名',
      'customer.number': '电话号码',
      'customer.birthday': '生日',
      'customer.inputaccount': '请输入账号',
      'customer.inputname': '请输入姓名',
      'customer.inputnumber': '请输入电话号码',
      'customer.selectdate': '请选择日期',
      'customer.subscriptionstatus': '订阅状态',
      'customer.password': '密码',
      'customer.inputpassword': '请输入密码',
      'customer.confirmationpassword': '确认密码',
      'customer.enterconfirmationpassword': '请输入确认密码',
      'customer.atypism': '两次输入密码不一致',
      'customer.country': '国家',
      'customer.region': '地区',
      'customer.detailedaddress': '详细地址',
      'customer.inputdetailedaddress': '请输入详细地址',
      'customer.addressinformation': '地址信息',
      'customer.pointsrecord': '积分记录',
      'customer.coupon': '优惠券',
      'customer.wechatmessage': '微信留言',
      'customer.messagecontent': '留言内容',
      'customer.historicalorders': '历史订单',
      'customer.postcode': '邮编',
      'customer.defaultaddress': '默认地址',
      'customer.setdefault': '设为默认',
      'customer.bonuspoints': '赠送积分',
      'customer.addtime': '添加时间',
      'customer.describe': '描述',
      'customer.notice': '是否通知',
      'customer.noticeEmail': '邮件通知',
      'customer.noticeWeiXin': '微信通知',
      'customer.inputdescribe': '请选择变更理由',
      'customer.revenueexpenditure': '收入/支出',
      'customer.remarks': '备注',
      'customer.inputremarks': '请输入备注',
      'customer.duedate': '到期时间',
      'customer.rewardpoints': '奖励积分',
      'customer.customerpointsavailable': '客户可用积分',
      'customer.couponname': '优惠券名称',
      'customer.couponno': '优惠券编号',
      'customer.collectiontime': '领取时间',
      'customer.noused': '未使用',
      'customer.used': '已使用',
      'customer.leavingmessage': '留言',
      'customer.sendcontent': '发送内容',
      'customer.sendingtime': '发送时间',
      'customer.orderno': '订单编号',
      'customer.orderstate': '订单状态',
      'customer.orderamount': '订单金额（含税）',
      'customer.paytype': '支払方法',
      'customer.ordertime': '下单时间',
      'customer.tobepaid': '待支付',
      'customer.tobedelivered': '待发货',
      'customer.delivered': '已发货',
      'customer.completed': '已完成',
      'customer.cancelled': '已取消',
      'customer.inputcontent': '请输入留言内容',
      'customer.messagepreview': '留言预览',
      'customer.ordernotice': '订单通知',
      'customer.noticecontent': '通知内容',
      'customer.noticetime': '通知时间',
      'customer.contact': '有问题联系我们',
      'customer.inputbonuspoints': '请输入赠送积分',
      'customer.addaddress': '新建地址',
      'customer.updateaddress': '编辑地址',
      'customer.ifdefaultaddress': '是否默认地址',
      'customer.postalcode': '邮政编码',
      'customer.inputpostalcode': '请输入邮政编码',
      'customer.inputaccountname': '请输入账号/姓名',
      'customer.subscriptionstatusprop': '营销邮件提醒',
      'customer.sendout': '发送',
      'customer.note': '客服备注',
      'customer.confirmpassword': '确认密码',
      'customer.inputnote': '请输入客服备注',
      'customer.uniqueCode': '唯一码',
      'customer.tel_error': '电话号格式错误',
      'customer.email_error': '电子邮件格式错误',
      'customer.customerKeyword_placeholder': '客户邮箱/客户电话/客户昵称',
      'customer.importTemplate': '模板示例',
      'customer.importSuccess': '上传成功',
      customerList: {
        customerInfo: '账户信息',
        customer: '账户',
        placeholder1: '注册电话/邮箱',
        customerInfo2: '得意先信息',
        placeholder2: '得意先名称/电话',
        dyxProductNo: '得意先编号',
        dyxName: '得意先名称',
        erpCustomerPhone: '得意先电话',
        payerCode: '请求先编号',
        sellerName: '担当者',
        whyError: '失败原因',
        rule1: '邮箱注册账户的账户邮箱不能为空',
        rule2: '手机注册账户的账户手机号不能为空',
        rule3: '请输入正确的账户邮箱',
        rule4: '请先绑定得意先编号',
        approvalResult: '审核结果',
        customerStatus: '账户状态',
        erpCustomerStatus: '得意先状态',
        registStatus: '注册类型',
        dyxGrouped: '得意先分组',
        inviteCode: '邀请码',
        placeholder3: '请输入邀请码',
        customerStatus3: '请求先',
        customerStatus4: '业态',
        customerStatus5: '担当者',
        placeholder4: '可以通过【导入】功能将ERP中的得意先信息导入到订货系统。',
        pass: '通过',
        refuse: '拒绝',
        approval: '待审核',
        registTime: '注册时间',
        self: '自主',
        invite: '邀请',
        normal: '正常',
        notNormal: '取引終了',
        editLook: '查看',
        updateUser: '修改账户',
        email: '账户邮箱',
        phone: '账户手机号',
        placeholder5: '请输入',
        importMsg1: '1.请先从友盛ERP中导出得意先信息，导出请勾选这些信息：得意先请先从友盛ERP中导出得意先信息，导出请勾选这些信息：得意先',
        importMsg2: '1.请按照提供的',
        importMsg3: '模板示例',
        importMsg4: '将得意先编号、货运方式（0：自提，1：自社便，2：邮寄）整理到模板文件中。',
        importMsg5: '2.上传模板文件，完成得意先信息的导入。',
        import: '上传',
        import2: '导入',
        importError: '导入失败得意先列表',
        success: '导入批次：第{num3}次\xa0\xa0\xa0\xa0成功：{num1}个\xa0\xa0\xa0\xa0失败：{num2}个',
        cancel: '取消',
        approvalStatus: '审核状态',
        bind: '绑定',
        email2: '邮编',
        addressDetail: '详细地址',
        departmentName: '部门名',
        quoteCondition: '取引条件',
        transportType: '货运方式',
        selectTransport: '请选择货运方式',
        approvalPass: '审核通过',
        approvalRefuse: '审核拒绝',
        save: '保存',
        yes: '是',
        no: '否',
        bindErp: '绑定ERP得意先',
        pls: '请输入',
        query: '查询',
        destinationCode: '直送先code',
        erpLastUpdateTime: 'ERP更新時間',
        name: '姓名',
        phone2: '电话号码',
        defaultAddress: '默认地址',
        updateTime: '更新时间',
        preGet: '获取前',
        afterGet: '获取后',
        sendbyPost: '邮寄',
        pickUp: '自提',
        zibianshe: '自社便',
        error1: '请输入得意先编号',
        saveSuccess: '保存成功',
        payway1: '月结',
        payway2: '现金',
        payway3: '货到付款',
        partment1: '营业1部',
        partment2: '营业2部',
        customerSync: '同步得意先信息',
        inviteReg: '邀请注册',
        inviteRegUrl: '邀请注册链接：',
        erpCustomerEmail: '得意先邮箱',
        sendSuccess: '发送成功',
        email_error: '邮箱格式不正确',
        sendFaild: '发送失败',
        searchPl: '请输入搜索内容',
        selfDefineProduct: '自定义商品',
        all: '全部',
        selfDefine: '自定义',
        importTimes: '导入批次',
        importResultTitle: '导入得意先结果',
        delErp: '删除得意先和账户',
        delCustomer: '仅删除账户',
        confirmDelErp: '确定要删除账户吗？',
        importversion: '第{num}次',
        appversion: 'APP版本号',
        emialNotice: '邮件通知：',
        phoneNotice: '短信通知：',
        remark: '备注',
        addAccount: '新增账号',
        tmpPwd: '临时密码',
        placeEmailOrPhonetip: '电话或邮箱至少输入一个',
        placeTmpPwd: '请输入临时密码',
        placeEmail: 'メールアドレスを入力してください。',
        placePhone: '電話番号を入力してください。',
        inviteUsed: '已使用数量',
        inviteTotal: '邀请码总数量',
        inviteCount: '邀请码数量',
        newInvite: '新增',
        inviteCountRequired: '请输入邀请码数量',
        used: '已使用',
        noused: '未使用',
        sellerName2: '店名·担当者名',
        confirmDelAddress: '确定要删除详细地址吗？',
        delayTime: 'リードタイム'
      },
      contactUs: {
        name: '姓名',
        identity: '身份',
        customerEmail: '邮箱',
        phone: '联系电话',
        country: '地区',
        addressPost: '邮编',
        addressDetail: '详细地址',
        companyName: '公司名称',
        consultationType: '咨询类型',
        consultationContent: '咨询/反馈内容',
        consultationTypeList: {
          consultationType1: '取引商談',
          consultationType2: 'サービス案内',
          consultationType3: '見積依頼',
          consultationType4: '商品に関する質問',
          consultationType5: '相談、苦情',
          consultationType6: '求人と応募関係',
          consultationType7: 'その他'
        },
        createTime: '問い合わせ時間'
      },
      erpGoods: {
        goodsContent: '商品信息',
        erpContent: '得意先信息',
        goodsType: '类型',
        transport: '运输温度',
        brand: '品牌',
        source: '原产地',
        rongliang: '容量/入数',
        lastBuy: '上次购买时间',
        updateTime: '更新时间',
        systemGoods: '系统商品',
        buyGoods: '已购商品',
        selfGoods: '自定义商品',
        erpGoods: '得意先商品'
      }
    },
    JP: {
      'customer.customerinfo': '客户信息',
      'customer.officialaccount': '关注公众号',
      'customer.availablepoints': '可用积分',
      'customer.sourceofregistration': '注册来源',
      'customer.registrationtime': '登録時間',
      'customer.orderquantity': '订单数量',
      'customer.blacklist': '黑名单',
      'customer.recentactivetime': '最近活跃时间',
      'customer.accumulatedamount': '累计金额',
      'customer.sureblock': '你确定要拉黑吗？',
      'customer.relievesureblock': '你确定要解除拉黑吗？',
      'customer.block': '拉黑',
      'customer.relieveblock': '解除拉黑',
      'customer.loginfrontend': '登录前端',
      'customer.email': 'メールアドレス',
      'customer.customername': '名前',
      'customer.number': '電話番号',
      'customer.birthday': '生日',
      'customer.inputaccount': '请输入账号',
      'customer.inputname': '请输入姓名',
      'customer.inputnumber': '请输入电话号码',
      'customer.selectdate': '请选择日期',
      'customer.subscriptionstatus': '订阅状态',
      'customer.password': '密码',
      'customer.inputpassword': '请输入密码',
      'customer.confirmationpassword': '确认密码',
      'customer.enterconfirmationpassword': '请输入确认密码',
      'customer.atypism': '两次输入密码不一致',
      'customer.country': '国家',
      'customer.region': '地域',
      'customer.detailedaddress': '详细地址',
      'customer.inputdetailedaddress': '请输入详细地址',
      'customer.addressinformation': '住所情報',
      'customer.pointsrecord': '积分记录',
      'customer.coupon': '优惠券',
      'customer.wechatmessage': '微信留言',
      'customer.messagecontent': '留言内容',
      'customer.historicalorders': '历史订单',
      'customer.postcode': '郵便番号',
      'customer.defaultaddress': '默认地址',
      'customer.setdefault': '设为默认',
      'customer.bonuspoints': '赠送积分',
      'customer.addtime': '添加时间',
      'customer.describe': '描述',
      'customer.notice': '是否通知',
      'customer.noticeEmail': '邮件通知',
      'customer.noticeWeiXin': '微信通知',
      'customer.inputdescribe': '请选择变更理由',
      'customer.revenueexpenditure': '收入/支出',
      'customer.remarks': '备注',
      'customer.inputremarks': '请输入备注',
      'customer.duedate': '到期时间',
      'customer.rewardpoints': '奖励积分',
      'customer.customerpointsavailable': '客户可用积分',
      'customer.couponname': '优惠券名称',
      'customer.couponno': '优惠券编号',
      'customer.collectiontime': '领取时间',
      'customer.noused': '未使用',
      'customer.used': '已使用',
      'customer.leavingmessage': '留言',
      'customer.sendcontent': '发送内容',
      'customer.sendingtime': '发送时间',
      'customer.orderno': '订单编号',
      'customer.orderstate': '订单状态',
      'customer.orderamount': '订单金额（税込）',
      'customer.paytype': '支付方式',
      'customer.ordertime': '下单时间',
      'customer.tobepaid': '待支付',
      'customer.tobedelivered': '待发货',
      'customer.delivered': '已发货',
      'customer.completed': '已完成',
      'customer.cancelled': '已取消',
      'customer.inputcontent': '请输入留言内容',
      'customer.messagepreview': '留言预览',
      'customer.ordernotice': '订单通知',
      'customer.noticecontent': '通知内容',
      'customer.noticetime': '通知时间',
      'customer.contact': '有问题联系我们',
      'customer.inputbonuspoints': '请输入赠送积分',
      'customer.addaddress': '新建地址',
      'customer.updateaddress': '编辑地址',
      'customer.ifdefaultaddress': '是否默认地址',
      'customer.postalcode': '邮政编码',
      'customer.inputpostalcode': '请输入邮政编码',
      'customer.inputaccountname': '请输入账号/姓名',
      'customer.subscriptionstatusprop': '营销邮件提醒',
      'customer.sendout': '送信',
      'customer.note': '客服备注',
      'customer.confirmpassword': '确认密码',
      'customer.inputnote': '请输入客服备注',
      'customer.uniqueCode': '唯一码',
      'customer.tel_error': '電話番号フォーマットエラー',
      'customer.email_error': '电子邮件格式错误',
      'customer.customerKeyword_placeholder': '客户邮箱/客户电话/客户昵称',
      'customer.importTemplate': 'テンプレート例',
      'customer.importSuccess': 'アップロード成功',
      'customer.showFirstTime': '登録情報を表示',
      'customer.firstTimeTime': '登録情報',
      'customer.mastPostTip': '支払い方法に代金引換が含まれる場合、配送方法は郵送を選択する必要があります。',
      'customer.mastPostTip2': '支払い方法が代金引換のみの場合、配送方法は郵送のみ選択できます。',
      customerList: {
        customerInfo: 'アカウント情報',
        customer: 'アカウント',
        placeholder1: '登録電話/メール/ア力ウント備考',
        customerInfo2: '得意先情報',
        placeholder2: '得意先名/電話',
        dyxProductNo: '得意先コード',
        dyxName: '得意先名',
        erpCustomerPhone: '得意先の電話',
        payerCode: '請求先コード',
        sellerName: '担当者',
        whyError: '失敗原因',
        rule1: 'アカウントのメールアドレスを入力してください',
        rule2: 'アカウントの携帯電話番号を入力してください',
        rule3: '正しいアカウントのメールを入力してください',
        rule4: '得意先コードを先に紐付けしてください',
        approvalResult: '審査結果',
        customerStatus: 'アカウント状態',
        erpCustomerStatus: '得意先状態',
        registStatus: '登録タイプ',
        dyxGrouped: '得意先グループ',
        inviteCode: '招待コード',
        placeholder3: '招待コードを入力してください',
        customerStatus3: '請求先',
        customerStatus4: '業態（得意先区分3）',
        customerStatus5: '担当者',
        placeholder4: '【インポート】機能を通じてERPの得意先情報を発注システムにインポートできます。',
        pass: 'OK',
        refuse: '拒否',
        approval: '審査待ち',
        registTime: '登録時間',
        self: '自己登録',
        invite: '招待登録',
        normal: '正常',
        notNormal: '取引終了',
        editLook: 'チェック',
        updateUser: 'アカウントの修正',
        email: 'アカウントのメール',
        phone: 'アカウントの携帯電話番号',
        placeholder5: '入力してください',
        importMsg1: '1.请先从友盛ERP中导出得意先信息，导出请勾选这些信息：得意先请先从友盛ERP中导出得意先信息，导出请勾选这些信息：得意先',
        importMsg2: '1.提供された通りに',
        importMsg3: 'テンプレート例',
        importMsg4: '得意先コード、配送方法（0：引取、1：自社便、2：郵送）をテンプレートファイルに整理してください。',
        importMsg5: '2.テンプレートファイルをアップロードして、得意先情報のインポートを完了してください。',
        import: 'アップロード',
        import2: 'インポート',
        importError: 'インポート失敗の得意先リスト',
        success: '一括インポート：第{num3}回\xa0\xa0\xa0\xa0成功：{num1}件\xa0\xa0\xa0\xa0失敗：{num2}件',
        cancel: 'キャンセル',
        approvalStatus: '審査状況',
        bind: '紐付け',
        email2: '郵便番号',
        addressDetail: '詳細住所',
        departmentName: '部署名',
        quoteCondition: '取引条件',
        transportType: '配送方法',
        selectTransport: '配送方法を選択してください',
        approvalPass: '審査OK',
        approvalRefuse: '審査拒否',
        save: '保存',
        yes: 'はい',
        no: 'いいえ',
        bindErp: 'ERP得意先の紐付け',
        pls: '入力してください',
        query: '検索',
        destinationCode: '直送先コード',
        erpLastUpdateTime: 'ERP更新時間',
        name: '名前',
        phone2: '電話番号',
        defaultAddress: '既定の住所',
        updateTime: '更新時間',
        preGet: '取得前',
        afterGet: '取得後',
        sendbyPost: '郵送',
        pickUp: '引取',
        zibianshe: '自社便',
        error1: '得意先コードを入力してください',
        saveSuccess: '保存成功',
        payway1: '月末締め',
        payway2: '現金／振込',
        payway3: '代金引換',
        partment1: '第一営業部',
        partment2: '第二営業部',
        customerSync: '得意先情報を同期する',
        inviteReg: '招待登録',
        inviteRegUrl: '招待登録リンク：',
        erpCustomerEmail: '顧客メールアドレス',
        sendSuccess: '送信成功',
        email_error: 'メールアドレスの形式が正しくありません',
        sendFaild: '送信失敗',
        searchPl: '検索内容を入力してください',
        selfDefineProduct: 'カスタム商品',
        all: 'すべて',
        selfDefine: 'カスタム',
        importTimes: '一括インポート',
        importResultTitle: '得意先のインポート結果',
        delErp: '得意先とアカウントを削除',
        delCustomer: 'アカウントのみ削除',
        confirmDelErp: 'アカウントを削除してもよろしいですか？',
        importversion: '第{num}回',
        appversion: 'アプリバージョン',
        emialNotice: 'メール通知：',
        phoneNotice: 'SMS通知：',
        remark: 'ア力ウント備考',
        addAccount: '新しいアカウント',
        tmpPwd: '仮パスワード',
        placeEmailOrPhonetip: '電話番号またはメールアドレスのいずれかを入力してください',
        placeTmpPwd: '仮パスワードを入力してください',
        newAccountTitle: '新しいアカウント',
        backRegister: '代理登録',
        placeEmail: 'メールアドレスを入力してください。',
        placePhone: '電話番号を入力してください。',
        inviteUsed: '使用済み数量',
        inviteTotal: '招待コードの総数',
        inviteCount: '招待コードの数量',
        newInvite: '追加',
        inviteCountRequired: '招待コードの数量を入力してください',
        used: '使用済',
        noused: '未使用',
        sellerName2: '店名·担当者名',
        confirmDelAddress: '詳細住所を削除してもよろしいですか？',
        delayTime: 'リードタイム'
      },
      contactUs: {
        name: '名前',
        identity: '利用形態',
        customerEmail: 'メールアドレス',
        phone: '連絡先電話番号',
        country: '地域',
        addressPost: '郵便番号',
        addressDetail: '詳細住所',
        companyName: '会社名',
        consultationType: '内容タイプ',
        consultationContent: '相談/フィードバック内容',
        consultationTypeList: {
          consultationType1: '取引商談',
          consultationType2: 'サービス案内',
          consultationType3: '見積依頼',
          consultationType4: '商品に関する質問',
          consultationType5: '相談、苦情',
          consultationType6: '求人と応募関係',
          consultationType7: 'その他'
        },
        createTime: '問い合わせ時間'
      },
      erpGoods: {
        goodsContent: '商品情報',
        erpContent: '得意先情報',
        goodsType: 'タイプ',
        transport: '輸送温度',
        brand: 'ブランド',
        source: '原産地',
        rongliang: '容量/入数',
        lastBuy: '前回購入日時',
        updateTime: '更新時間',
        systemGoods: '系统商品',
        buyGoods: '已购商品',
        selfGoods: 'カスタム商品',
        erpGoods: 'マイ商品'
      }
    }
  }
};